import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { Broom, EyeShow, Info } from 'styled-icons/fluentui-system-regular';
import PropTypes from 'prop-types';
import database, { secondDatabase } from '../../../../model/firebase/firebase';
import { ShowNotification } from '../../../Notifications';
import { palette } from '../../../../system/styles/styles';
import JobDetailModal from '../../modal/jobDetails';
import VacancyDetailModal from '../../modal/vacancyDetails';
import notFound from '../../../../assets/not-found.gif';
import { startShowVacancies } from '../../../../redux/actions/_initializer_actions';
import { DeleteVacancyContainer } from '../../../../system/styles/components/deleteVacancy';

const DeleteVacancy = (props) => {
  const { className } = props;
  const dispatch = useDispatch();

  const [state, setState] = React.useState({
    renderModal: false,
    showModal: false,
    currentJob: {},
    applicants: [],
    vacancies: [],
    showModalVacancy: false,
    filterVacancies: '',
  });

  const { vacancies } = useSelector((state) => state);
  const { platform } = useSelector((state) => state);

  const getData = () => {
    setState((prevState) => ({
      ...prevState,
      vacancies,
    }));
  };

  const manageVacancy = async (data) => {
    const newValues = vacancies.find((job) => data.jobID === job.jobID);

    newValues.Status = false;
    newValues.Permission = 'Rejected';

    if (data.ATS) {
      await database.collection(`${platform.platformName}/data/vacancies`).doc(data.jobID).update({ Status: false });
      ShowNotification('success', `Se eliminó la vacante de la plataforma correctamente`, 'Todo bien');
      getData();
    } else {
      await database
        .collection(`${platform.platformName}/data/companies`)
        .doc(`${data.vacancyOwner}/jobs/${data.jobID}`)
        .update({ Status: false });
      await database.collection(`${platform.platformName}/data/vacancies`).doc(data.jobID).update({ Status: false });
      ShowNotification('success', `Se eliminó la vacante de la plataforma correctamente`, 'Todo bien');
      getData();
    }
  };

  const showMore = (data) => {
    setState((prevState) => ({
      ...prevState,
      currentJob: data,
      showModal: true,
      renderModal: true,
    }));
  };

  const loadStudents = async (id, owner, ats) => {
    if (ats) {
      const data = await secondDatabase
        .collection(`companies/${owner}/jobs/${id}/organicCanidate`)
        .where('platformOrigin', '==', platform.platformFullName)
        .get();
      setState((prevState) => ({
        ...prevState,
        applicants: data,
        renderModalVacancy: true,
        showModalVacancy: true,
      }));
    } else {
      const data = await database
        .collection(`${platform.platformName}/data/companies/${owner}/jobs/${id}/applicants`)
        .get();
      setState((prevState) => ({
        ...prevState,
        applicants: data,
        renderModalVacancy: true,
        showModalVacancy: true,
      }));
    }
  };

  const ToggleModal = () => {
    setState((prevState) => ({
      ...prevState,
      showModal: !prevState.showModal,
      renderModal: !prevState.renderModal,
    }));
  };

  const ToggleModalVacancy = () => {
    setState((prevState) => ({
      ...prevState,
      showModalVacancy: !prevState.showModalVacancy,
      renderModalVacancy: !prevState.renderModalVacancy,
      applicants: [],
    }));
  };

  const formatDate = (date) => {
    const event = new Date(date);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = event.toLocaleDateString('es-ES', options);
    const dateFinal = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    return dateFinal === 'Invalid Date' ? 'Sin Fecha Registrada' : dateFinal;
  };

  const handleFilters = (e) => {
    const { target } = e;
    const query = target.value;
    setState((prevState) => ({
      ...prevState,
      filterVacancies: query,
      vacancies: vacancies
        .filter((vacancy) => {
          const vacancyName = vacancy.jobTitle.toLowerCase().includes(query.toLowerCase());
          const companyName = vacancy.companyName.toLowerCase().includes(query.toLowerCase());
          return vacancyName || companyName;
        })
        .sort((a, b) => {
          return a.names < b.names;
        }),
    }));
  };

  React.useEffect(() => {
    getData();
    dispatch(startShowVacancies());
  }, [vacancies]);

  return (
    <DeleteVacancyContainer className={className} adminColor={platform?.adminColor}>
      <div className="filterContainer">
        <input
          value={state.filterVacancies}
          name="filterVacancies"
          onChange={handleFilters}
          className="search-bar"
          placeholder="Ejemplo: QA tester o Lapieza.io"
        />
      </div>
      <Grid container spacing={1}>
        {/* eslint-disable-next-line array-callback-return,consistent-return */}
        {state.vacancies.map((job, index) => {
          if (job.Status && job.Permission === 'accept') {
            return (
              <Grid item xl={4} lg={6} md={6} key={job.jobID}>
                <div className="vacancyCard" key={job.jobID}>
                  <article className="job">
                    <div>
                      <div className="job-image" style={{ backgroundImage: `url(${job.img})` }} />
                      <div className="job-content">
                        <div className="job-base">
                          <div className="job-logo">
                            <img src={job.logo} alt="" />
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              showMore(job);
                            }}
                            className="viewMore-btn">
                            <Info size={20} color="#fff" />
                          </button>
                          <h4>{job.companyName}</h4>
                          <h3>{job.jobTitle}</h3>
                          <p className="companyName">
                            Publicado el:{' '}
                            <b>{` ${
                              job?.postedFrom ? formatDate(job?.postedFrom) : dayjs(job?.createdAt).format('DD/MM/YYYY')
                            } `}</b>
                          </p>
                          <p className="companyName">
                            Dias restantes de la vacante:{' '}
                            <b>{` ${dayjs(job.createdAt).add(60, 'days').diff(dayjs().valueOf(), 'days')} `}</b>
                          </p>
                          <Grid container spacing={1}>
                            <Grid item lg={4}>
                              <p className="companyName">
                                Total de candidatos: <b>{job.applicantsCount}</b>{' '}
                              </p>
                            </Grid>
                            <Grid item lg={4}>
                              <p
                                className="seeMore"
                                onClick={() => {
                                  loadStudents(job.jobID, job.vacancyOwner, job.ATS);
                                }}>
                                <EyeShow size={20} color="#fff" /> Postulantes
                              </p>
                            </Grid>
                            <Grid item lg={4}>
                              <button type="button" className="deleteButton" onClick={() => manageVacancy(job, index)}>
                                <Broom size={20} color="#fff" /> Eliminar
                              </button>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </Grid>
            );
          }
        })}
        {vacancies.length === 0 ? (
          <>
            <img src={notFound} alt="" className="text-no" />
            <p className="text-center">No hay vacantes que mostrar</p>
          </>
        ) : null}
        {state.renderModal ? (
          <JobDetailModal data={state.currentJob} open={state.showModal} close={ToggleModal} />
        ) : null}
        <VacancyDetailModal apps={state.applicants} open={state.showModalVacancy} close={ToggleModalVacancy} />
      </Grid>
    </DeleteVacancyContainer>
  );
};

DeleteVacancy.propTypes = {
  className: PropTypes.string,
};
DeleteVacancy.defaultProps = {
  className: '',
};
export default DeleteVacancy;
